"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModalBody_1 = __importDefault(require("./ModalBody"));
exports.default = ModalBody_1.default;
